var Module = {
    name: 'activity',
    options: {
        isBot: $('meta[name="is_bot"]').attr('content'),
        testMode: $('meta[name="test_mode"]').attr('content')
    },

    pageLoad: function (page) {
        var step = 'frontend.page.' + page;

        $(document).ready(function () {
            Module.send(step + '.loading');
        })

        $(window).on('load', function() {
            Module.send(step + '.loaded');
        })
    },

    form: function (page, action, data = null) {
        Module.send('frontend.form.' + page + '.' + action, 0, data);
    },

    formErrorResponse: function (page, response) {
        var statusCode = parseInt(response.status),
            action = 'error';

        if (statusCode === 400) {
            switch (response.responseJSON.code) {
                case 'user_exists':
                    action = 'user_exists_error';
                    break;
            }
        }

        if (statusCode === 422) {
            action = 'validation_error'
        }

        Module.form(page, action);
    },

    payment: function (action, data = null) {
        Module.form('payment', action, data);
    },

    donation: function (action) {
        Module.form('donation', action);
    },

    send: function (step, retries, data = null) {
        console.log('Step:', step);

        retries = retries || 0;
        if (
            retries > 5
            || process.env.MIX_INTEGRATION_DISABLED === "true"
            || Module.options.isBot
            || Module.options.testMode
        ) {
            return;
        }

        var dateTime = Math.floor(Date.now() / 1000);

        var url = process.env.MIX_INTEGRATION_API_HOST + '/'  + process.env.MIX_INTEGRATION_API_ACTIVITY_URL,
            data = {
                token: $('meta[name="user-token"]').attr('content'),
                step: step,
                order_id: $('meta[name="order"]').attr('content'),
                date: dateTime,
                data: data
            }

        $.ajax({
            type: 'POST',
            url: url,
            dataType: "json",
            data: data,
            crossDomain: true,
            headers: {
                'Accept': 'application/json'
            }
        }).done(function(response) {
        }).fail(function(response) {
            var status = parseInt(response.status)
            if (status >= 500) {
                setTimeout(function () {
                    Module.send(step, data.order_id, ++retries)
                }, 10000);
            }
        })
    }
}

module.exports = Module
